import React from 'react';
import type { JobOfferLetter, JobOfferSection, JobOfferSignature } from '../../../types/hiring';
import { employeeFullName, LCTF_OFFER_COMPANY, LCTF_OFFER_LEGAL } from '../../../utils/jobOfferLetter';

type Props = {
  sections: JobOfferSection[];
  employeeName: string;
  ceoName: string;
  ceoTitle: string;
  ceoSignature?: JobOfferSignature | null;
  employeeSignature?: JobOfferSignature | null;
  documentTitle?: string;
  companySignName?: string;
};

export function JobOfferPreview({
  sections,
  employeeName,
  ceoName,
  ceoTitle,
  ceoSignature,
  employeeSignature,
  documentTitle = 'Offer Letter',
  companySignName,
}: Props) {
  return (
    <article className="job-offer-preview">
      <header className="job-offer-preview-mast">
        <p className="job-offer-preview-kicker">{LCTF_OFFER_COMPANY}</p>
        <h3>{documentTitle}</h3>
        <p>{LCTF_OFFER_LEGAL}</p>
        <p><strong>Employee:</strong> {employeeName || '—'}</p>
      </header>
      {sections.map(section => (
        <section key={section.id} className="job-offer-preview-section">
          <h4>{section.heading}</h4>
          {section.body.split('\n\n').map((para, i) => (
            <p key={i} style={{ whiteSpace: 'pre-wrap' }}>{para}</p>
          ))}
        </section>
      ))}
      <footer className="job-offer-sign-blocks">
        <div>
          <strong>{companySignName || LCTF_OFFER_COMPANY}</strong>
          {ceoSignature?.dataUrl ? (
            <img src={ceoSignature.dataUrl} alt={`${ceoName} signature`} className="job-offer-sig-img" />
          ) : (
            <div className="job-offer-sig-line" />
          )}
          <p>Name: {ceoSignature?.signedBy || ceoName}</p>
          <p>Title: {ceoSignature?.title || ceoTitle}</p>
          <p>Date: {ceoSignature?.signedAt ? ceoSignature.signedAt.toLocaleDateString() : '—'}</p>
        </div>
        <div>
          <strong>Employee</strong>
          {employeeSignature?.dataUrl ? (
            <img src={employeeSignature.dataUrl} alt={`${employeeName} signature`} className="job-offer-sig-img" />
          ) : (
            <div className="job-offer-sig-line" />
          )}
          <p>{employeeName || '—'}</p>
          <p>Date: {employeeSignature?.signedAt ? employeeSignature.signedAt.toLocaleDateString() : '—'}</p>
        </div>
      </footer>
    </article>
  );
}

export function offerPreviewFromLetter(offer: JobOfferLetter) {
  return {
    sections: offer.sections,
    employeeName: employeeFullName(offer.fields),
    ceoName: offer.fields.ceoName,
    ceoTitle: offer.fields.ceoTitle,
    ceoSignature: offer.ceoSignature,
    employeeSignature: offer.employeeSignature,
    documentTitle: 'Offer Letter',
  };
}

export default JobOfferPreview;
